const state = {
  searchQuery: '',
  paginationQuery: {},
  selected: [],
};

export { state };
